import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/evaluation_type', component: List, name: 'evaluation_type.index'},
  {path: '/evaluation_type/store', component: Form, name: 'evaluation_type.store'},
  {path: '/evaluation_type/:id', component: Form, name: 'evaluation_type.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/evaluation_type/routes.js